import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import * as Actions from "@/store/actions.type";
import * as Mutations from "@/store/mutations.type";
import { firebaseAuth } from "@/common/firebase";
import router from "@/router";

export default {
  state: {
    errors: null,
    user: null,
    isAuthenticated: false
  },
  mutations: {
    [Mutations.SET_USER_ERROR](state, error) {
      state.errors = error;
    },
    [Mutations.SET_AUTH](state, user) {
      state.isAuthenticated = true;
      state.user = user;
      state.errors = null;
    },
    [Mutations.PURGE_AUTH](state) {
      state.isAuthenticated = false;
      state.user = null;
      state.errors = null;
    }
  },
  actions: {
    [Actions.LOGIN]({ commit }, credentials) {
      signInWithEmailAndPassword(
        firebaseAuth,
        credentials.email,
        credentials.password
      )
        .then((userCredential) => {
          commit(Mutations.SET_AUTH, userCredential.user);
          router.push({ name: "admin" });
        })
        .catch((error) => {
          commit(Mutations.SET_USER_ERROR, error);
        });
    },
    [Actions.LOGOUT]({ commit }) {
      signOut(firebaseAuth)
        .then(() => {
          commit(Mutations.PURGE_AUTH);
          router.push({ name: "auth" });
        })
        .catch(({ error }) => {
          commit(Mutations.SET_USER_ERROR, error);
        });
    }
  },
  getters: {
    userErrors(state) {
      return state.errors;
    },
    currentUser(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    }
  }
};
